import { render } from "./jspdf-practice.vue?vue&type=template&id=57bf649b"
import script from "./jspdf-practice.vue?vue&type=script&lang=js"
export * from "./jspdf-practice.vue?vue&type=script&lang=js"

import "./jspdf-practice.vue?vue&type=style&index=0&id=57bf649b&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__